<p-toast position="top-right"></p-toast>

<p-dialog [(visible)]="displayModalAddHearingOrReason" [modal]="true" [style]="{width: '620px', height: '75vh'}"
          [draggable]="false" [resizable]="false" (onHide)="cancel()">
    <div class="m-0 disciplinary-reason-body">
        <p class="disciplinary-reason-title">{{hearingOrReasonTitle}}</p>
        <p class="disciplinary-reason-description">{{hearingOrReasonDescription}}</p>
    </div>
    <p-scrollPanel [style]="{width:'100%', height: 'calc(40vh - 0px)'}"
                   [styleClass]="'app-scrollpanel'">
        <div class="flex flex-column mt-2" *ngIf="disciplinaryActionId === disciplinaryActionEnum.Closed">
            <div class="flex flex-row">
                <div class="disciplinary-reason-label">Reason:</div>
                <div class="mt-10" style="width: 300px;">
                    <p-dropdown placeholder="Select reason" [(ngModel)]="data.reasonId" [options]="disciplinaryReasonsList"
                                optionLabel="name" optionValue="value" [showClear]="true"></p-dropdown>
                </div>
            </div>
            <div class="flex flex-column mt-2">
                <div class="disciplinary-reason-label">Reason:</div>
                <div class="mt-10">
                    <textarea rows="5" cols="30" [(ngModel)]="data.reason" placeholder="Please describe the reason for this decision." pInputTextarea [autoResize]="true"></textarea>
                </div>
            </div>
        </div>
        <div class="flex flex-column mt-2" *ngIf="disciplinaryActionId === disciplinaryActionEnum.Suspension || disciplinaryActionId === disciplinaryActionEnum.Ban">
            <div class="flex flex-row">
                <div class="disciplinary-reason-label">Hearing Location:</div>
                <div class="mt-10" style="width: 300px;">
                    <p-dropdown placeholder="Select reason" [(ngModel)]="data.hearingLocationId" [options]="disciplinaryActionList"
                                optionLabel="name" optionValue="value" [showClear]="true"></p-dropdown>
                </div>
            </div>
            <div class="flex flex-row mt-2">
                <div class="disciplinary-reason-label">Hearing Date:</div>
                <div class="mt-10" style="width: 300px;">
                    <p-calendar [(ngModel)]="data.hearingDateTime" [showTime]="false" [showSeconds]="false" [appendTo]="'body'"></p-calendar>
                </div>
            </div>
            <div class="flex flex-row mt-2">
                <div class="disciplinary-reason-label">Hearing Time:</div>
                <div class="mt-10" style="width: 300px;">
                    <p-calendar [(ngModel)]="data.hearingTime" [timeOnly]="true" [hourFormat]="'12'" [appendTo]="'body'"></p-calendar>
                </div>
            </div>
        </div>
    </p-scrollPanel>
    <div class="flex justify-content-end mt-20" *ngIf="!loading">
        <div>
            <button pButton pRipple type="button" label="Cancel" class="outlined-white-btn" (click)="displayModalAddHearingOrReason = false"></button>
        </div>
        <div class="ml-20">
            <button pButton pRipple type="button" label="Submit" class="bluedark-btn" (click)="submit()"></button>
        </div>
    </div>
    <div *ngIf="loading" style="text-align: center;">
        <p-progressSpinner [style]="{width: '40px', height: '40px'}" styleClass="custom-spinner" strokeWidth="5" fill="var(--surface-ground)" animationDuration="1s"></p-progressSpinner>
    </div>
</p-dialog>
